module.exports = __webpack_public_path__ + "media/audio4.915534a0.mp3";